<div
    class="view-rounded-button"
    [class.view-rounded-button--outline]="buttonType === 'outline'"
    [class.view-rounded-button--solid]="buttonType === 'solid'"
    [class.view-rounded-button--shadow]="shadow"
    [class.view-rounded-button--compact]="compact"
    [class.view-rounded-button--reverse]="iconPlacement === 'right'">

    <app-icon class="view-rounded-button__icon mh-1" [icon]="icon" *ngIf="icon"></app-icon>

    <div class="view-rounded-button__label mh-1">{{ label }}</div>

</div>
